document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-vienli-buybox]').forEach(initBuybox);
});

function formatMoney(cents) {
  return (cents / 100).toFixed(2).replace('.', ',') + ' €';
}

function initGalleryThumbs(root) {
  var mainWrap = root.querySelector('[data-vienli-gallery-main]');
  var mainImg = mainWrap ? mainWrap.querySelector('img') : null;
  var thumbs = root.querySelectorAll('[data-vienli-thumb]');
  if (!mainImg || !thumbs.length) return;

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var fullSrc = thumb.getAttribute('data-full-src');
      if (fullSrc) {
        mainImg.src = fullSrc;
        // The main image may have an auto-generated responsive srcset from `image_tag`;
        // drop it so the browser doesn't override our explicit src choice.
        mainImg.removeAttribute('srcset');
      }
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });
}

function initBuybox(root) {
  initGalleryThumbs(root);

  var mapEl = root.querySelector('[data-vienli-variant-map]');
  var variantMap = mapEl ? JSON.parse(mapEl.textContent) : {};
  var secondaryGroup = root.querySelector('[data-vienli-secondary-group]');
  var state = { secondary: '', tier: '' };

  var firstTier = root.querySelector('[data-vienli-tier]');
  if (firstTier) state.tier = firstTier.getAttribute('data-tier-value');
  if (secondaryGroup) {
    var firstPill = secondaryGroup.querySelector('.vienli-product-hero__secondary-pill');
    if (firstPill) state.secondary = firstPill.getAttribute('data-vienli-secondary-value');
  } else {
    var secondaryDefault = root.querySelector('[data-vienli-secondary-default]');
    if (secondaryDefault) state.secondary = secondaryDefault.getAttribute('data-vienli-secondary-default');
  }

  function currentVariant() {
    return variantMap[state.secondary + '||' + state.tier];
  }

  function recalcTotal() {
    var variant = currentVariant();
    if (!variant) {
      // No variant matches the current secondary/tier combination (e.g. a secondary value
      // with no priced tiers slipped through). Leave the previously-displayed total as-is
      // instead of painting a misleading "0,00 €" — the add-to-cart handler is responsible
      // for surfacing the "not available" error in this state.
      return;
    }
    var addonsTotal = 0;
    root.querySelectorAll('[data-vienli-addon]:checked').forEach(function (cb) {
      addonsTotal += parseInt(cb.getAttribute('data-amount'), 10);
    });
    var total = variant.amount + addonsTotal;
    root.querySelectorAll('[data-vienli-total], [data-vienli-total-sticky]').forEach(function (el) {
      el.textContent = formatMoney(total);
    });
  }

  root.querySelectorAll('[data-vienli-tier]').forEach(function (row) {
    row.addEventListener('click', function () {
      root.querySelectorAll('[data-vienli-tier]').forEach(function (r) {
        r.classList.remove('is-selected');
        r.querySelector('input[type="radio"]').checked = false;
      });
      row.classList.add('is-selected');
      row.querySelector('input[type="radio"]').checked = true;
      state.tier = row.getAttribute('data-tier-value');
      recalcTotal();
    });
  });

  if (secondaryGroup) {
    secondaryGroup.querySelectorAll('[data-vienli-secondary-value]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        secondaryGroup.querySelectorAll('[data-vienli-secondary-value]').forEach(function (p) {
          p.classList.remove('is-active');
        });
        pill.classList.add('is-active');
        state.secondary = pill.getAttribute('data-vienli-secondary-value');
        recalcTotal();
      });
    });
  }

  root.querySelectorAll('[data-vienli-addon]').forEach(function (cb) {
    cb.addEventListener('change', recalcTotal);
  });

  // Shared in-flight guard: the desktop add-to-cart button and the mobile sticky
  // add-to-cart button each have their own listener over this same root, so a click on
  // either one must disable BOTH (using the real `disabled` property, not just
  // `aria-disabled`) until the request settles — otherwise a second click on the other
  // button can fire a duplicate add-to-cart request.
  var addButtons = root.querySelectorAll('[data-vienli-add]');
  var addInFlight = false;

  function setAddButtonsDisabled(disabled) {
    addButtons.forEach(function (b) {
      b.disabled = disabled;
      if (disabled) {
        b.setAttribute('aria-disabled', 'true');
        b.classList.add('loading');
      } else {
        b.removeAttribute('aria-disabled');
        b.classList.remove('loading');
      }
    });
  }

  addButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (addInFlight || btn.disabled) return;

      var variant = currentVariant();
      var statusEl = root.querySelector('[data-vienli-status]');
      if (!variant) {
        if (statusEl) {
          statusEl.textContent = 'Esa combinación no está disponible todavía. Prueba con otra opción.';
          statusEl.hidden = false;
          statusEl.setAttribute('data-state', 'error');
        }
        return;
      }
      var items = [{ id: variant.id, quantity: 1 }];
      root.querySelectorAll('[data-vienli-addon]:checked').forEach(function (cb) {
        items.push({ id: cb.getAttribute('data-variant-id'), quantity: 1 });
      });

      addInFlight = true;
      setAddButtonsDisabled(true);
      if (statusEl) { statusEl.hidden = true; statusEl.removeAttribute('data-state'); }

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error(data.description || 'No se ha podido añadir el producto al carrito.');
            return data;
          });
        })
        .then(function () {
          window.location = window.routes.cart_url;
        })
        .catch(function (error) {
          if (statusEl) {
            statusEl.textContent = error.message;
            statusEl.hidden = false;
            statusEl.setAttribute('data-state', 'error');
          }
        })
        .finally(function () {
          addInFlight = false;
          setAddButtonsDisabled(false);
        });
    });
  });

  recalcTotal();
}
